/**
 * Handle form submit events
 */
const formHandler = (function (window, jQuery) { // eslint-disable-line no-unused-vars
	'use strict';
     const PGM_ATTR = 'data-pgm', KEY_ATTR = 'data-key', AJAX_FORM_INPUT = 'ajax_form',
          SUBMIT_BUTTON = '<input type="hidden" name="btn_search" value="1"/>';
	
     function doSubmit($el) {
          let action = $el.attr(PGM_ATTR),
               $body =  jQuery('body'),
               isAjaxForm = false,
               $form = jQuery('<form>').attr({method:'POST',action})

          $body.find(`[data-pgm=${action}] :input`).each(function(){
               let $el = jQuery(this);

               isAjaxForm = getIsAjaxForm($el);

               if($el.attr('name') == AJAX_FORM_INPUT){
                    isAjaxForm = parseInt($el.val() || 0) > 0;
               }

               $form.append($el.clone());
          });

          $form.append(SUBMIT_BUTTON);

          if(isAjaxForm) {

               return;
          }
          m
          $body.append($form);
          $form.trigger('submit');
	}
     function getIsAjaxForm($el){
          if($el.attr('name') == AJAX_FORM_INPUT){
               return parseInt($el.val() || 0) > 0;
          }
          return false;
     }
	function loadPageAreas(pgm, html){
          let $body =  jQuery('body');
          let doc = new DOMParser().parseFromString(html, 'text/html');
          $body.find(`[data-pgm=${pgm}]`).each(function(){
               let key= jQuery(this).attr(KEY_ATTR);
               let $newEl = jQuery(doc).find(`[data-key=${key}]`);
               jQuery(this).replaceWith($newEl);
          });

     }
     function doPaging(){

     }
     function doSearch(){

     }
     function doSort(){

     }
     function reportSubmit(){

     }
	return {
	};
}(window, jQuery));
